import { AxiosResponse } from 'axios'

import get from 'lodash/get'
import { IFilter, Where } from 'types/common'
import { AggregationPipeline } from 'types/common/aggregation'
import { api, handleError } from 'API'
import { ITag } from 'interfaces/tag'

export async function getTagsByAggregate(pipeline: AggregationPipeline): Promise<ITag[]> {
  try {
    const response: AxiosResponse = await api.post(`/tags/aggregate`, {
      pipeline
    })
    return response?.data
  } catch (error: any) {
    return []
  }
}

export async function getTags(filter: IFilter<ITag>): Promise<ITag[]> {
  try {
    const response = await api.get(`/tags?filter=${JSON.stringify(filter)}`)
    return response.data
  } catch (error: any) {
    handleError(error as Error, 'API/tag.ts', 'getTags')
    return []
  }
}

export async function getTagDetail(id: string, filter: IFilter<ITag>): Promise<ITag> {
  try {
    const response = await api.get(`/tags/${id}?filter=${JSON.stringify(filter)}`)
    return response.data
  } catch (error: any) {
    handleError(error as Error, 'API/tag.ts', 'getTagDetail')
    return {}
  }
}

export async function countTags(where: Where<ITag> = {}): Promise<number> {
  try {
    const { data = 0 } = await api.get(`/tags/count?where=${JSON.stringify(where)}`)
    return Number(get(data, 'count', 0))
  } catch (error: any) {
    handleError(error as Error, 'API/tag.ts', 'countTags')
    return 0
  }
}

export async function createTag(userData: ITag): Promise<ITag> {
  try {
    const response = await api.post(`/tags`, userData)
    return response.data
  } catch (error: any) {
    handleError(error as Error, 'API/tag.ts', 'createTag')
    return {}
  }
}

export async function updateTag(id: number, userData: ITag): Promise<ITag> {
  try {
    const response = await api.patch(`/tags/${id}`, userData)
    return response.data
  } catch (error: any) {
    handleError(error as Error, 'API/tag.ts', 'updateTag')
    return {}
  }
}

export async function deleteTag(id: number): Promise<void> {
  try {
    const response = await api.delete(`/tags/${id}`)
    return response.data
  } catch (error: any) {
    const errorMessage: string = get(error, 'response.data.error.message', '') || JSON.stringify(error)
    handleError(error as Error, 'API/tag.ts', 'deleteTag')
    throw new Error(errorMessage)
  }
}
